package com.hyperether.goodjob.scenes.landing

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material.Button
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.font.FontWeight
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.login_register
import com.hyperether.goodjob.resources.logo_dark_landing
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.WEB_SCREEN_SIZE_LIMIT
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun LandingHeader(
    continueToRegister: () -> Unit
) {
    Row(
        modifier = Modifier
            .widthIn(max = WEB_SCREEN_SIZE_LIMIT)
            .fillMaxWidth()
            .fillMaxHeight(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            alignment = Alignment.CenterStart,
            painter = painterResource(Res.drawable.logo_dark_landing),
            contentDescription = null,
            modifier = Modifier
                .height(47.toScaleDp())
                .width(203.toScaleDp())
        )

        Button(
            onClick = {
                continueToRegister()
            },
            modifier = Modifier
                .height(61.toScaleDp())
                .widthIn(min = 208.toScaleDp())
                .clip(RoundedCornerShape(56.toScaleDp()))
                .pointerHoverIcon(PointerIcon.Hand),
            colors = ButtonDefaults.buttonColors(Color.White),
        ) {
            DisableSelection {
                Text(
                    text = stringResource(Res.string.login_register),
                    color = BlueApp,
                    fontSize = 18.toScaleSp(),
                    fontWeight = FontWeight.Bold
                )
            }
        }
    }
}